// start:ng42.barrel
import './subjectclass-member-list.directive';
// end:ng42.barrel

